const getStreetViewAvailability = async (coords: {
  lat: number
  lng: number
}): Promise<boolean> => {
  if (!coords) {
    return false
  }

  // @ts-ignore: using global google
  const maps = window.google?.maps
  if (!maps || !maps.StreetViewService) {
    return false
  }

  // @ts-ignore: using global google types
  const sv = new maps.StreetViewService()

  try {
    const result = await new Promise<boolean>(resolve => {
      sv.getPanorama(
        { location: coords, radius: 50 },
        (_: unknown, status: string) => {
          // @ts-ignore: ignoring TS for maps.StreetViewStatus
          resolve(status === maps.StreetViewStatus.OK)
        }
      )
    })
    return result
  } catch {
    return false
  }
}

export default getStreetViewAvailability
